import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Vehicle insurance notification context enum
 * @description Notification contexts specific to vehicle insurance subjects
 */
export enum VehicleInsuranceNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Vehicle insurance-specific contexts
	PENDING = 'pending',
	ACTIVE = 'active',
	EXPIRED = 'expired',
}
